export default () => {
  const recommendBrowserPopup = $('#recommend-browser-popup-modal');
  const doNotShowAgain = localStorage.getItem('recommendBrowserPopup');

  if (recommendBrowserPopup && !doNotShowAgain) {
    recommendBrowserPopup.modal('show');
    recommendBrowserPopup.on('hidden.bs.modal', function () {
      if ($('#recommend-browser-popup').is(':checked')) {
        localStorage.setItem('recommendBrowserPopup', 1);
      }
    });
  }
};
